import { queryOptions } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { showProjectBillingSettings } from "~/modules/billing/api/billingSettings/billingSettingsApiDispatchers.ts";

export const billingSettingsQueries = {
	baseKey: ["billing-settings"],
	byProject: (projectId: string) =>
		queryOptions({
			queryKey: [...billingSettingsQueries.baseKey, "project", projectId],
			queryFn: () => showProjectBillingSettings(projectId).then(getDataFromResponse),
		}),
};